// This code was generated by AI.
import { gql } from '@apollo/client/core'

export const CAMPAIGN_FIELDS = gql`
  fragment CampaignFields on Campaign {
    id
    title
    active
    startsAt
    endsAt
    contentDeHtml
    contentEnHtml
    placement
    icon
    buttonLabelDe
    buttonLabelEn
    buttonPath
    createdAt
    updatedAt
  }
`

export const CURRENT_MANAGER_CAMPAIGNS_QUERY = gql`
  query CurrentManagerCampaigns {
    currentCampaigns(campaignType: MANAGER) {
      ...CampaignFields
    }
  }
  ${CAMPAIGN_FIELDS}
`
